var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contacts--list__item"},[_c('p'),_c('p',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.investor.balance,_vm.walletCurrency)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }